import { colors, FelaCSS, FelaCSSWithCustomSelectors, spacing } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
  titleWrap: FelaCSSWithCustomSelectors;
  title: FelaCSS;
  reviewsSlider: FelaCSSWithCustomSelectors;
}

const styles = (): IStyles => ({
  wrapper: {
    paddingTop: spacing[3],
  },
  titleWrap: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    margin: '0 0 27px 0',

    '& .suppler-add-review': {
      marginLeft: `-${spacing[2]}`,
    },

    maxWidthTabletSm: {
      margin: `${spacing[0]} ${spacing[4]} ${spacing[2]}`,
      height: 40,
    },
  },
  title: {
    color: colors.space,
    fontDefaultSemiBold: 22,
    lineHeight: '120%',
    margin: 0,
    cursor: 'default',

    maxWidthTabletSm: {
      margin: `${spacing[2]} ${spacing[0]}`,
    },
  },

  reviewsSlider: {
    marginBottom: '47px',

    maxWidthTabletSm: {
      marginBottom: spacing[4],
    },

    '& .alice-carousel__stage': {
      display: 'flex',
    },
    '& .alice-carousel__stage-item': {
      flex: '1 0 auto',
      height: 'auto',
    },
  },
});

export default styles;
